import { StayDuration } from 'components/package/expedia/enums';
import { StayState } from 'components/package/expedia/interfaces';

const initialStayState: StayState = {
  stayDuration: StayDuration.SEVEN_DAYS,
};

export { initialStayState };
